// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-quinn-residences -> quinn-residences-websites -> new-river-forest
// Generated: 2026-10-29T18:34:50.200Z
// Counts: 0 design, 26 content, 46 slot group, 0 collection binding, 6 section, 0 style

export const designOverrides = {};

export const contentOverrides = {
  "floorplanshero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Choose the layout that fits your day </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "easy-fee-guide-hero.lead": {
    "overrideType": "VALUE",
    "customValue": "<p>A simple breakdown of the fees, services, and optional costs associated with living at <span data-type=\"field-token\" data-field=\"property_name\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "easy-fee-guide-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Know your costs before you move in.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "engrain-sitemap.height": {
    "overrideType": "VALUE",
    "customValue": "1000",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.lead": {
    "overrideType": "VALUE",
    "customValue": "<p>Compare layouts, check availability, and find the space that fits how home needs to work.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "nextstep.title": {
    "overrideType": "VALUE",
    "customValue": "<p>See townhome living in person</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "tourquestions.when_a": {
    "overrideType": "VALUE",
    "customValue": "<p>The scheduler shows the times you can book.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "tourscheduler.widget.self_guided_tour_link": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_self_guided_tour_url"
  },
  "tourscheduler.widget.thank_you_url": {
    "overrideType": "VALUE",
    "customValue": "/thank-you",
    "generatedValue": null,
    "mappedField": null
  },
  "tourscheduler.widget.use_leads_tour_times": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Inside, in-unit washers and dryers, efficient appliances and electronic thermostats make the day easier. Outside your door are a pool, clubhouse, playground and pet park. See every <a href=\"/amenities\">community amenity</a>.</p>",
    "mappedField": null
  },
  "amenitieslist.title": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Pool days, yard time, smart homes</p>",
    "mappedField": null
  },
  "amenityhighlights.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Spend summer afternoons at the pool, meet neighbors at the clubhouse, let the kids loose on the playground, and give your dog room to run at the pet park, all a short walk from your front door.</p>",
    "mappedField": null
  },
  "feetable.concierge_note": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Includes a filter change twice a year, exterior pest control, 24-hour maintenance response for emergencies, and positive credit reporting.</p>",
    "mappedField": null
  },
  "floorplanshero.offer_label": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Move-in specials on select homes</p>",
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>New three- and four-bedroom rental homes in Bluffton</p>",
    "mappedField": null
  },
  "interactivemapcallout.title": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Find your open home, street by street.</p>",
    "mappedField": null
  },
  "lifestylehighlights.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>At New River Forest, the shared spaces fill in around a busy week: an afternoon swim at the pool, a stop at the dog park before dinner, and weekends when the kids head to the playground and neighbors meet up at the clubhouse. See the full list of <a href=\"/amenities\">community amenities</a>.</p>",
    "mappedField": null
  },
  "neighborhoodcallout.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>New Riverside Village and May River Commons are close by for groceries and dinner. Old Town Bluffton, the May River and Hilton Head Island make easy weekend trips. Explore the <a href=\"/neighborhood\">Bluffton neighborhood</a>.</p>",
    "mappedField": null
  },
  "neighborhoodcallout.title": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Lowcountry living in New Riverside</p>",
    "mappedField": null
  },
  "petpolicy.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Your pet gets a private fenced yard at home and an on-site pet park for playdates, and New Riverside Barn Park and the New River Linear Trail are close by for longer walks.</p>",
    "mappedField": null
  },
  "petpolicy.title": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Room to roam for every pet</p>",
    "mappedField": null
  },
  "touroptions.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Walk through the Cumberland, Sapelo, and Beaufort homes in <a href=\"/virtual-tours\">3D</a>, then see one in person on a <a href=\"/schedule-a-tour\">self-guided tour</a> or with our leasing team.</p>",
    "mappedField": null
  },
  "virtualtourembed.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Take a 3D walk through three of our homes: the three-bedroom Cumberland, plus the four-bedroom Beaufort and Sapelo. Pick a tour, then compare layouts on our <a href=\"/floor-plans\">floor plans</a> page.</p>",
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactdetails.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "mappedField": "",
        "customValue": "/thank-you"
      }
    }
  },
  "floorplanshero.link_fees": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/easy-fee-guide"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "floorplanshero.link_pets": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/pet-policy"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "whyquinn.pillar_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "description": {
        "type": "VALUE",
        "customValue": "Easy access to great schools, shopping, dining, and everyday essentials."
      }
    }
  },
  "whyquinn.pillar_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "description": {
        "type": "VALUE",
        "customValue": "Spacious layouts that blend functionality, comfort, and modern style."
      }
    }
  },
  "whyquinn.pillar_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Community-Focused Amenities"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Shared spaces designed to bring neighbors together and create lasting memories."
      }
    }
  },
  "whyquinn.pillar_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "description": {
        "type": "VALUE",
        "customValue": "Dedicated support and personalized service for a hassle-free rental experience."
      }
    }
  },
  "whyquinn.pillar_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "description": {
        "type": "VALUE",
        "customValue": "Energy-efficient homes built to reduce environmental impact and help lower your utility costs."
      }
    }
  },
  "amenitieslist.amenity_photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Electronic Thermostat"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167581/01a1169a-9963-712c-b8ae-8e793a675a72.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Living room with wood-look flooring, a ceiling fan, and two windows with blinds."
      }
    }
  },
  "amenitieslist.amenity_photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Pool"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167581/01a1169a-a846-738d-9e2d-9bce24caeea8.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior view of a modern multifamily property with a swimming pool and lounge chairs."
      }
    }
  },
  "amenitieslist.amenity_photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Playground"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167581/01a1169a-7ae8-72c8-aafd-33ca73b1a3c6.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Children playing on playground equipment in a park with palm trees and a building in the background."
      }
    }
  },
  "amenitieslist.amenity_photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Pet Park"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167581/01a1169a-88cd-7750-ae7e-8c29bebcae42.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of the neighborhood's green lawns and trees around the homes."
      }
    }
  },
  "amenitieslist.amenity_photo_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Clubhouse"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85d-9e3c-753a-800a-7cc822d99960.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "White clubhouse building beside the community pool."
      }
    }
  },
  "amenitieslist.amenity_photo_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Refrigerator"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167581/01a1169a-a8b6-726a-ac5d-93ea79865169.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Granite countertop with stainless steel appliances and white cabinetry in a modern kitchen."
      }
    }
  },
  "amenitieslist.photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167581/01a1169a-a87e-7100-857d-be74cc23c1fa.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Outdoor swimming pool and lounge area with umbrellas and chairs next to a modern white building."
      }
    }
  },
  "amenitygroups.community_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85d-9e3c-753a-800a-7cc822d99960.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Community pool with lounge chairs beside a white building at New River Forest"
      }
    }
  },
  "amenitygroups.home_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167581/01a1169a-7d5b-733e-8ea1-621d66c61135.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and a large island."
      }
    }
  },
  "amenityhighlights.card_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167581/01a1169a-a87e-7100-857d-be74cc23c1fa.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Outdoor swimming pool and lounge area with umbrellas and chairs next to a modern white building."
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Pool"
      }
    }
  },
  "amenityhighlights.card_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167581/01a1169a-a846-738d-9e2d-9bce24caeea8.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Clubhouse building overlooking the pool and lounge chairs"
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Clubhouse"
      }
    }
  },
  "amenityhighlights.card_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167581/01a1169a-7ae8-72c8-aafd-33ca73b1a3c6.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Children playing on playground equipment in a park with palm trees and a building in the background."
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Playground"
      }
    }
  },
  "amenityhighlights.card_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167581/019fc85b-bcec-70eb-a367-75cf9c06739b.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of a suburban neighborhood with rows of houses, winding streets, and a pond."
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Pond Views"
      }
    }
  },
  "amenityhighlights.card_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85d-9eba-744a-81a1-136261e28120.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Curving tree-lined street through the New River Forest neighborhood"
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Walkable Streets"
      }
    }
  },
  "amenityhighlights.card_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167581/01a1169a-915e-773c-893d-4060bff7db2c.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "White single-family home at New River Forest with black shutters and an attached two-car garage"
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Attached Garage"
      }
    }
  },
  "floorplanshero.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85d-8fb6-724e-b3fb-97022e93a596.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "A residential street with houses on both sides and cars parked on the side."
      }
    }
  },
  "floorplanshero.photo_10": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167581/01a1169a-7ae2-773a-a711-281f414dc7b9.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Spacious open-concept living area with a modern kitchen featuring white cabinets and stainless steel appliances."
      }
    }
  },
  "floorplanshero.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85d-9c7f-72cb-8337-3c86dac7984f.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Kitchen with white cabinets, granite countertops, stainless steel appliances, and an island."
      }
    }
  },
  "floorplanshero.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85d-9e3c-753a-800a-7cc822d99960.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Community swimming pool with lounge chairs beside a white clubhouse."
      }
    }
  },
  "floorplanshero.photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167581/01a1169a-8c61-779a-a722-dfe8958e0861.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Living room with a sectional sofa, coffee table, and adjacent kitchen with island."
      }
    }
  },
  "floorplanshero.photo_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85d-a0c7-769a-a2ec-116248acabe9.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of a new housing development with rows of houses and a pond."
      }
    }
  },
  "floorplanshero.photo_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85d-9dd3-7357-8078-7aaa31da6627.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "White single-family rental home with a black front door and attached garage."
      }
    }
  },
  "floorplanshero.photo_7": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167581/01a1169a-7d5b-733e-8ea1-621d66c61135.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and a large island."
      }
    }
  },
  "floorplanshero.photo_8": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85d-a670-7237-af9c-f9f7516c666b.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "A living room with a couch, a coffee table, and a ceiling fan."
      }
    }
  },
  "floorplanshero.photo_9": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167581/019fc85b-bcec-70eb-a367-75cf9c06739b.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of a suburban neighborhood with rows of houses, winding streets, and a pond."
      }
    }
  },
  "lifestylehighlights.highlight_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Poolside afternoons"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Take a lounge chair at the community pool and spend a warm Lowcountry afternoon swimming, reading, or just soaking up the sun."
      }
    }
  },
  "lifestylehighlights.highlight_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Meet the neighbors"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "The clubhouse, playground, and dog park make it easy to run into neighbors while the kids play and the dogs burn off energy."
      }
    }
  },
  "lifestylehighlights.highlight_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Room to focus"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "With three or four bedrooms, you can turn a spare room into a quiet home office, and smart-home tech keeps the house running while you work."
      }
    }
  },
  "neighborhoodcallout.photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85b-61c8-7535-851c-218b82552c31.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "New Riverside Barn Park in Bluffton, half a mile from New River Forest"
      },
      "caption": {
        "type": "GENERATOR",
        "generatedValue": "New Riverside Barn Park"
      }
    }
  },
  "petpolicy.photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167581/01a1169a-88cd-7750-ae7e-8c29bebcae42.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of a neighborhood with many houses, green lawns, and trees."
      },
      "caption": {
        "type": "GENERATOR",
        "generatedValue": "Green lawns and trees"
      }
    }
  },
  "propertyoverview.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167581/019fc85b-bcec-70eb-a367-75cf9c06739b.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of a suburban neighborhood with rows of houses, winding streets, and a pond."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Community"
      }
    }
  },
  "propertyoverview.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167581/01a1169a-8c61-779a-a722-dfe8958e0861.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Living room with a sectional sofa, coffee table, and adjacent kitchen with island."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Living Room"
      }
    }
  },
  "propertyoverview.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167581/01a1169a-9933-765e-a935-0cee9968cf15.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and island."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Kitchen"
      }
    }
  },
  "propertyoverview.photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167581/01a1169a-915e-773c-893d-4060bff7db2c.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior of a white single-family rental home with a two-car garage and black shutters."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Home Exterior"
      }
    }
  },
  "propertyoverview.photo_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167581/01a1169a-7ae2-773a-a711-281f414dc7b9.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Spacious open-concept living area with a modern kitchen featuring white cabinets and stainless steel appliances."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Open Living Area"
      }
    }
  },
  "propertyoverview.photo_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85d-9eba-744a-81a1-136261e28120.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "A curvy road in a residential area with houses on both sides."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Neighborhood Streets"
      }
    }
  },
  "reviewthemes.chip_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Caring staff"
      },
      "signal": {
        "type": "GENERATOR",
        "generatedValue": "Gabrielle was absolutely wonderful!"
      }
    }
  },
  "tourhero.photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167581/019fc85d-9dd3-7357-8078-7aaa31da6627.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "White townhome exterior with a black front door and attached garage, framed by green trees"
      }
    }
  }
};

export const collectionBindingOverrides = {};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "elise-chatbot",
      "blockId": "elise-chatbot",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "perq-floor-plan",
      "blockId": "perq-floor-plan",
      "position": 0
    }
  ]
};

export const styleOverrides = {};
